var NAMESPACE = 'td';

var Rate = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-rate", class: { 'td-rate--readonly': _vm.readonly } }, [_vm._l(5, function (n) {
      return _c('span', { key: n, staticClass: "td-rate__item", class: { 'is-on': _vm.v >= n, 'is-half': _vm.v > n - 1 && _vm.v < n }, on: { "mouseenter": function mouseenter($event) {
            return _vm.setCurrentValue(n);
          }, "mouseleave": _vm.resetCurrentValue, "click": function click($event) {
            return _vm.handleRate(n);
          } } }, [_vm._m(0, true)]);
    }), _vm._v(" "), _vm.textVisible || _vm.showScore ? _c('span', { staticClass: "td-rate__text" }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2) : _vm.showText ? _c('span', { staticClass: "td-rate__text" }, [_vm._v(" " + _vm._s(_vm.text) + " ")]) : _vm._e()], 2);
  }, staticRenderFns: [function () {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('i', { staticClass: "td-icon-star" }, [_c('i', { staticClass: "td-icon-star-half" })]);
  }],
  name: NAMESPACE + '-rate',

  props: {
    value: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 5
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // 老属性，已经弃用，但是保持兼容
    textVisible: {
      type: Boolean,
      default: false
    },
    showScore: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    },
    texts: {
      type: Array,
      default: function _default() {
        return ['不满意', '一般', '一般', '满意', '非常满意'];
      }
    }
  },

  data: function data() {
    return {
      currentValue: this.value
    };
  },


  computed: {
    v: function v() {
      if (this.readonly) {
        return this.value / this.total * 5;
      } else {
        return this.currentValue / this.total * 5;
      }
    },
    text: function text() {
      var result = '';
      if (this.showScore || this.textVisible) {
        result = this.v;
      } else if (this.showText) {
        result = this.texts[Math.ceil(this.v) - 1];
      }
      return result;
    }
  },

  methods: {
    setCurrentValue: function setCurrentValue(n) {
      if (this.readonly) return;
      this.currentValue = n * this.total / 5;
    },
    resetCurrentValue: function resetCurrentValue() {
      if (this.readonly) return;
      this.currentValue = this.value;
    },
    handleRate: function handleRate() {
      if (this.readonly) return;
      this.$emit('input', this.currentValue);
      this.$emit('change', this.currentValue);
    }
  }
};

Rate.install = function (Vue) {
  Vue.component(Rate.name, Rate);
};

export default Rate;
